import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Container, Grid, Typography } from 'components/base';

import { THEMES } from './homeCarousel';

import CarouselBgLeft from '../../../public/static/img/carousel-item-bg-left.svg';
import CarouselBgRight from '../../../public/static/img/carousel-item-bg-right.svg';

const HeroBanner = forwardRef((props, ref) => {
  const theme = THEMES[3];

  const className = classNames({
    carousel: true,
    'hero-banner': true,
    [props.className]: props.className,
  });

  return (
    <div ref={ref} className={className} style={{ backgroundColor: theme.backgroundColor }}>
      <Container>
        <Grid.Row className={props.inverted ? 'flex-row-reverse' : undefined}>
          <Grid.Col xs={12} md={6} className="hero-banner-bg">
            <span
              className="hero-banner-bg-left"
              style={{
                color: theme.color,
                opacity: theme.opacity,
              }}
            >
              <CarouselBgLeft />
            </span>
            <span
              className="hero-banner-bg-right"
              style={{ color: theme.color, opacity: theme.opacity }}
            >
              <CarouselBgRight />
            </span>
            <div className="hero-banner-data">
              <Typography.H2>{props.title}</Typography.H2>
              <Typography.H3 className={classNames({ 'text-black': true, 'mb-5': props.button })}>
                {props.description}
              </Typography.H3>
              {props.button}
            </div>
          </Grid.Col>
          <Grid.Col xs={12} md={6}>
            {props.children}
          </Grid.Col>
        </Grid.Row>
      </Container>
    </div>
  );
});

HeroBanner.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  button: PropTypes.node,
  className: PropTypes.string,
  inverted: PropTypes.bool,
  children: PropTypes.node,
};

export default HeroBanner;
